<template>
  <div class="hello">
    <div class="hello-bottom"></div>
    <div class="content">
      <img alt="logo" src="../assets/woliu2.svg">
      <p>
        沃流智能深耕于金融、房地产、物业回款管理多个领域，公司以自主研发的资产管理系统、AI机器人外呼系统、智能数据分析系统和GPT大模型为技术支撑，结合与知名律所和仲裁机构的合作，打造了“AI智催+专家攻坚+多维法催”的立体回款体系。
      </p>
      <p>
        而深圳沃流企业管理有限公司作为沃流智能下专门负责回款管理的公司，自2022年8月成立以来，已联合集团搭建了AI沟通/咨询系统、物业费收缴智能化系统，并串联建设“AI+专家联动”创新模式以实现全方位回款管理。
      </p>
      <p>我们期待与您携手合作，共创美好未来！<br />联系电话：4009630638</p>
      <section class="item">
        <div class="itemd-cell">
          <h>120万+</h>
          <p>调解语料</p>
        </div>
        <div class="sept"></div>
        <div class="itemd-cell">
          <h>1000+</h>
          <p>意图标签</p>
        </div>
        <div class="sept"></div>
        <div class="itemd-cell">
          <h>100+</h>
          <p>场景话术</p>
        </div>
      </section>
      
    </div>
    <section class="copyright">Copyright © 2024 深圳沃流企业管理有限公司 <a @click="onCopyrightClick">粤ICP备2026042481号</a></section>
  </div>
</template>

<script>

export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  methods: {
    onCopyrightClick() {
      window.open('https://beian.miit.gov.cn');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.hello {
  height: 100%;
  background-image: url('../assets/bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #f5f5f5;
}
.hello-bottom {
  width: 100%;
    height: 50%;
    position: fixed;
    bottom: 0;
    background-image: url('../assets/bg-bottom.png');
    background-size: cover;
    background-position: bottom;
    background-repeat: no-repeat;
    background-color: transparent;
}
.content {
  padding-left: 20%;
  width: 50%;
  text-align: left;
}
.content img {
  margin-top: 10%;
}

.content p {
  font-size: 17px;
  color: #FFFFFF;
  line-height: 29px;
  text-align: left;
  font-style: normal;
  display: inline-block;
  margin-bottom: 10px;
}

.item {
  margin-top: 64px;
  display: flex;
}

.itemd-cell{
  width: 100px;
}

.sept {
  width: 1px;
  height: 85px;
  background: #FFFFFF4F;
  margin: 0 64px;
}

.item h {
  font-weight: 500;
  font-size: 30px;
  color: #FFFFFF;
  line-height: 50px;
  text-align: left;
  font-style: normal;
}

.item p {
  font-size: 16px;
  color: #FFFFFF;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  display: inline-block;
  margin: 0;
}


.copyright {
  color: #FFFFFF;
  position: fixed;
  bottom: 32px;
  font-size: 14px;
  text-align: center;
  width: 100%;
}

.copyright a {
  color: #FFFFFF;
  cursor: pointer;
}

</style>
